import * as React from "react";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {logOut} from "../store/action/user/user";
import {RootState} from "../store/reducer/root/RootState";
import {match, Redirect, Route} from "react-router";
import {History} from 'history';
import {workRoutes} from "./route/HeaderRoutes";
import NotificationService from "../service/NotificationService";
import User from "../model/user/User";
import TermOfServicePage from "../components/auth/TermOfServicePage";
import Footer from "../components/layout/footer/Footer";
import Header from "../components/layout/header/Header";
import BodyRouter from "./BodyRouter";
import AccessDisablePage from "../components/auth/AccessDisablePage";
import RevolutAuthorization from "../components/accounting/RevolutAuthorization";
import PartnerMigration from "../components/accounting/partnerMigration/PartnerMigration";
import XeroAuthorization from "../components/accounting/XeroAuthorization";
import PubNubService from "../service/PubNubService";
import {PubNubSettings} from "../model/settings/Settings";
import {Option} from "ts-option";

const Fragment = (React as any).Fragment;

interface ReduxProps {
	/**
	 * Indicates if user is logged in.
	 */
	loggedIn: boolean;
	/**
	 * Logged in user detail
	 */
	user: User;
	/**
	 * PubNub settings
	 */
	pubNubSettings: Option<PubNubSettings>
}

interface DispatchProps {
	/**
	 * Logout dispatch action.
	 */
	logout: () => void
}

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
	/**
	 * Location url.
	 */
	location: History.LocationState;
}

type Props = ReduxProps & DispatchProps & RouteProps;

/**
 * Main component of the application.
 */
class AppRouter extends React.Component<Props, {}> {
	componentDidMount() {
		if (this.props.loggedIn){
			NotificationService.startPulling();
			this.props.pubNubSettings.map(s => PubNubService.init(s, this.props.user.id))
		}
	}

	componentWillUnmount() {
		NotificationService.stopPulling();
	}

	render() {
		if (!this.props.loggedIn) {
			return <Redirect
				to={{pathname: '/auth/signin', state: {from: this.props.location.pathname + this.props.location.search}}}/>;
		}
		if (this.props.location.pathname == this.props.match.url + "/revolut/authorize") {
			return <Route component={RevolutAuthorization}/>
		}
		if (this.props.location.pathname == this.props.match.url + "/partner/migrate") {
			return <Route component={PartnerMigration}/>
		}
		if (this.props.location.pathname == this.props.match.url + "/xero/authorize") {
			return <Route component={XeroAuthorization}/>
		}
		if (!this.props.user.hasLoginPerm()) {
			return <Route component={AccessDisablePage}/>
		}
		if (!this.props.user.hasAcceptedToS()) {
			return <Route component={TermOfServicePage}/>
		}
		return (
			<Fragment>
				<Header menuData={workRoutes}/>
				<div className={"body-router-wrapper"}>
					<Route key={"body"} path={this.props.match.url} component={BodyRouter}/>
				</div>
				<Footer/>
			</Fragment>
		)
	}
}


function mapStateToProps(state: RootState) {
	return {
		loggedIn: state.user.user.isDefined,
		user: state.user.user.orNull,
		pubNubSettings: state.settings.settings.flatMap(s => s.pubnubSettings)
	}
}


function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		logout: () => dispatch(logOut()),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter)